export const purchaseQuestions: Record<string, any> = {
  propertyPrice: {
    labelKey: 'applicationForm.PURCHASE.propertyPrice.label',
  },
  financeAmount: {
    labelKey: 'applicationForm.PURCHASE.financeAmount.label',
  },
};
